<template>
  <div>
    <Header title="学籍预警"></Header>
    <div class="grey-contain" v-if="schoolCode == '10894'" v-for="(item,index) in yjkcList" :key="index">
      <span style="margin-top: 5px;" class="warn-ttl">学年学期: {{item.xnxqid}}</span>
      <span class="warn-ttl">学号: {{item.xh}}</span>
      <span class="warn-ttl">姓名: {{item.xm}}</span>
      <span class="warn-ttl">班级名称: {{item.bj}}</span>
      <span class="warn-ttl">课程名称: {{item.kcmc}}</span>
      <span class="warn-ttl">总成绩: {{item.zcj}}</span>
      <span class="warn-ttl">课程性质: {{item.kcxz}}</span>
      <span class="warn-ttl">课程属性: {{item.kcxs}}</span>
      <span class="warn-ttl">学分: {{item.xf}}</span>
      <span class="warn-ttl">补重学期: {{item.bcxq}}</span>
      <span class="warn-ttl">是否获得学分: {{item.sfhdxf}}</span>
    </div>
    <div class="warn" v-else>
      <p class="warn-ttl">{{this.curWarnList.warningName}}</p>
      <p class="warn-year">{{this.curWarnList.semester}}</p>
      <p class="warn-info">上课专业：{{this.curWarnList.majorName}}</p>
      <p class="warn-info">处理结果：{{this.curWarnList.resultName}}</p>
    </div>
  </div>
</template>

<script>
  import { Api } from '../../../utils/axios'
  export default{
    data(){
      return{
        schoolCode:'',
        curWarnList:[],
        yjkcList:[]
      }
    },
    methods:{
      async getList(){
        const params = {
          warningId : this.$route.query.id,
          dxid:this.$route.query.dxid
        }
        const res = await Api.getWarningDetail(params)
        if(this.schoolCode == '10894'){
          this.yjkcList = res.list;
        } else{
          this.curWarnList = res.data[0]
        }
      }
    },
    created(){
      this.schoolCode = sessionStorage.getItem("schoolCode");
      this.getList()
    },
  }
</script>

<style lang="less" scoped>
  .warn{padding: 20px;}
  .warn .warn-ttl{font-size: 24px;color: @attendance-background-color-13;font-weight: 600;margin-bottom: 20px;}
  .warn .warn-year{font-size: 18px;color: @attendance-color-1;font-weight: 600;margin-bottom: 8px;}
  .warn .warn-info{font-size: 14px;color: @attendance-color-2;margin-bottom: 8px;}

  .grey-contain{flex-direction: column;align-items: flex-start;justify-content: center;line-height: 17px;}
  .grey-contain p{font-weight: 600;line-height: 22px;margin-bottom: 4px;}
  .grey-contain span{color: @attendance-color-2;font-size: 12px;line-height: 17px;}
</style>



// WEBPACK FOOTER //
// src/components/student/statusManage/warnDetail.vue